import { z } from "zod";

export const SchemaSimulasi = z.object({
  nama: z
    .string({
      required_error: "Nama wajib diisi",
      invalid_type_error: "Nama harus berupa teks",
    })
    .min(1, "Nama wajib diisi"),

  whatsapp: z
    .string({
      required_error:
        "Whatsapp wajib diisi, perhitungan detail akan kami kirimkan melalui whatsapp.",
      invalid_type_error: "Whatsapp harus berupa teks",
    })
    .trim()
    .min(9, "Nomor WhatsApp terlalu pendek, isi dengan nomor WhatsApp aktif.")
    .max(14, "Nomor WhatsApp terlalu panjang, isi dengan nomor WhatsApp aktif.")
    .startsWith(
      "08",
      'Format nomor salah, awali dengan "08", contoh: 085123123123.'
    ),

  lebar: z.preprocess(
    (val) => (val === "" || val === null ? undefined : Number(val)),
    z
      .number({
        required_error: "Lebar tanah wajib diisi",
        invalid_type_error: "Lebar tanah harus berupa angka",
      })
      .min(1, "Lebar tanah wajib diisi")
  ),

  panjang: z.preprocess(
    (val) => (val === "" || val === null ? undefined : Number(val)),
    z
      .number({
        required_error: "Panjang tanah wajib diisi",
        invalid_type_error: "Panjang tanah harus berupa angka",
      })
      .min(1, "Panjang tanah wajib diisi")
  ),

  bahan: z.enum(["murah", "menengah", "premium"], {
    errorMap: () => ({ message: "Jenis bahan bangunan harus dipilih" }),
  }),
});
